import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=45ddaa7e&scoped=true"
import script from "./SummaryOrder.vue?vue&type=script&lang=ts"
export * from "./SummaryOrder.vue?vue&type=script&lang=ts"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=45ddaa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ddaa7e",
  null
  
)

export default component.exports